import AppConstants from '../config/app.constants';

let BranchPerformanceService = function ($http, $q) {

    let getRouteMessenger = (startDate, endDate, branchIds, eventRoute) => {
        return $http
            .post(AppConstants.api + `/branch-performance/get-route-messenger`, {
                startDate,
                endDate,
                branchIds,
                eventRoute
            })
            .then((res) => {
                return res.data
            })
    }

    let getRouteStats = (startDate, endDate, branchIds, eventRoute, messengerId) => {
        return $http
            .post(AppConstants.api + `/branch-performance/get-routes-stats`, {
                startDate,
                endDate,
                branchIds,
                eventRoute,
                messengerId
            })
            .then((res) => {
                return res.data
            })
    }

    let getOrderStats = (startDate, endDate, branchIds, orderType, account, status) => {
        return $http
            .post(AppConstants.api + `/branch-performance/get-orders-stats`, {
                startDate, 
                endDate, 
                branchIds, 
                orderType, 
                account,
                status
            })
            .then((res) => {
                return res.data
            })
    }

    let getServiceOrderAction = () => {
        return $http
            .post(AppConstants.api + `/branch-performance/get-service-order-actions`, {})
            .then((res) => {
                return res.data
            })
    }

    let getServiceTicketStats = (startDate, endDate, branchIds, status, actionCode) => {
        return $http
            .post(AppConstants.api + `/branch-performance/get-service-tickets-stats`, {
                startDate, 
                endDate, 
                branchIds, 
                status, 
                actionCode
            })
            .then((res) => {
                return res.data
            })
    }

    return {
        getRouteMessenger,
        getRouteStats,
        getOrderStats,
        getServiceOrderAction,
        getServiceTicketStats
    }
}

BranchPerformanceService.$inject = ["$http", "$q"];

export default BranchPerformanceService;


// WEBPACK FOOTER //
// ./client/app/services/branch-performance.service.js